<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  props: {
    legendPosition: {
      type: String,
      default: 'right',
    },
    labels: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  watch: {
    legendPosition(nextPosition) {
      this.updateLegendPosition(nextPosition);
    },
  },
  methods: {
    updateLegendPosition(nextPosition = this.legendPosition) {
      const chart = this.$data._chart;
      if (!chart || !chart.options.legend) return;
      const position = nextPosition || 'right';
      if (chart.options.legend.position == position) return;
      chart.options.legend.position = position;
      chart.update(0);
    },
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: [
              '#7F77DD', // Lavender
              '#AFA9EC', // Periwinkle
              '#378ADD', // Ocean
              '#6FAED9', // Soft Sky
              '#9C8ADE', // Muted Violet
              '#CFA6B8', // Dusty Rose
              '#E6D8F2', // Soft Lilac
              '#EDC1CF', // Soft Blush
            ],

            borderColor: '#FFFFFF',
            borderWidth: 2,

            hoverBorderWidth: 3,
            hoverOffset: 6,

            data: this.data,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,

        title: {
          display: Boolean(this.title),
          text: this.title,
          fontSize: 11,
          fontStyle: 'normal',
          padding: 8,
        },

        legend: {
          position: this.legendPosition,
          align: 'center',
          // eslint-disable-next-line no-empty-function
          onClick: () => {},
          labels: {
            boxWidth: 12,
            padding: 8,
            generateLabels: (chart) => {
              const data = chart.data;
              const dataset = data.datasets[0];
              const total = dataset.data.reduce((a, b) => a + b, 0);

              return data.labels.map((label, i) => {
                const value = dataset.data[i];
                const percent = ((value / total) * 100).toFixed(1);

                return {
                  text: `${label} (${percent}%)`,
                  fillStyle: dataset.backgroundColor[i],
                  hidden: isNaN(value),
                  index: i,
                };
              });
            },
          },
        },
      },
    );
  },
};
</script>

<style scoped>
div {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  position: relative;
}
</style>
